import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const Error = ({ error }) => {
	const labels = useLabels();
	return (
		<div
			className="alert-warning alert mb-0 m-auto"
			style={{ width: 'fit-content' }}
		>
			<i aria-hidden="true" className="ddc-icon ddc-icon-alert" />
			<div className="alert-content">
				<strong>{labels.get('ERROR')}:</strong>
				<span> {error}</span>
			</div>
		</div>
	);
};

Error.propTypes = {
	error: PropTypes.string
};

export default Error;
